import { render, staticRenderFns } from "./FileDetail.vue?vue&type=template&id=0c82e328&scoped=true&"
import script from "./FileDetail.vue?vue&type=script&lang=js&"
export * from "./FileDetail.vue?vue&type=script&lang=js&"
import style0 from "./FileDetail.vue?vue&type=style&index=0&id=0c82e328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c82e328",
  null
  
)

export default component.exports